<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.services.index">
        <template v-slot:title>
          <span>{{ $t("services.users") }}</span>
        </template>
        <template v-slot:preview>
          <b-tabs content-class="mt-1" fill>
            <b-tab :title="$t('services.service_information')" active>
              <p>
                <b-row v-if="isTechnician">
                <b-col class="text-center mb-1 mt-1" lg="12" md="12" sm="12" xl="12">
                  <i class="bx bx-play fa-3x mr-2 ml-2 cursor-pointer text-warning border-box"
                     @click="actionService(1)"
                     v-if="!form.time || (form.time && form.time.type_id === 2)"
                     :title="$t('services.start_action')">
                  </i>
                  <i class="bx bx-pause fa-3x mr-2 ml-2 cursor-pointer text-danger border-box"
                     @click="showServiceDescriptionModal(2)"
                     v-if="form.time && form.time.type_id === 1"
                     :title="$t('services.pause_action')">
                  </i>
                  <i class="bx bx-stop fa-3x ml-2 cursor-pointer text-success border-box"
                     @click="showServiceDescriptionModal(3)"
                     v-if="form.time && form.time.type_id === 1"
                     :title="$t('services.finish_action')">
                  </i>
                </b-col>
              </b-row>
                <b-row>
                <b-col lg="6" md="6" sm="12" xl="6">
                  <b-form-group :label="$t('services.service_type')">
                    <multiple-select-input
                        v-if="serviceTypes"
                        :model.sync="form.service_type_id"
                        :multiple="false"
                        :disabled="isTechnician"
                        :values="serviceTypes"
                        label="name"
                        track-by="id"
                    ></multiple-select-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('service_type_id') && !$v.form.service_type_id.required"
                        :state="validateState('service_type_id') && $v.form.service_type_id.required">
                      {{ $t('services.validations.service_type.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6">
                  <b-form-group :label="$t('services.service_status')">
                    <multiple-select-input
                        v-if="serviceStatuses"
                        :model.sync="form.service_status_id"
                        :multiple="false"
                        :disabled="isCustomer"
                        :values="serviceStatuses"
                        label="name"
                        track-by="id"
                    ></multiple-select-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('service_status_id') && !$v.form.service_status_id.required"
                        :state="validateState('service_status_id') && $v.form.service_status_id.required">
                      {{ $t('services.validations.service_status.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6">
                  <b-form-group :label="$t('services.institution')">
                    <multiple-select-input
                        v-if="institutions"
                        :model.sync="form.institution_id"
                        :multiple="false"
                        :values="institutions"
                        :disabled="isTechnician"
                        label="name"
                        track-by="id"
                    ></multiple-select-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('institution_id') && !$v.form.institution_id.required"
                        :state="validateState('institution_id') && $v.form.institution_id.required">
                      {{ $t('services.validations.institution.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6">
                  <b-form-group :label="$t('services.branch')">
                    <multiple-select-input
                        v-if="branches"
                        :model.sync="form.branch_id"
                        :multiple="false"
                        :values="branches"
                        :disabled="isTechnician"
                        label="name"
                        track-by="id"
                    ></multiple-select-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('branch_id') && !$v.form.branch_id.required"
                        :state="validateState('branch_id') && $v.form.branch_id.required">
                      {{ $t('services.validations.branch.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>


                <b-col lg="6" md="6" sm="12" xl="6">
                  <b-form-group :label="$t('services.customer')">
                    <multiple-select-input
                        v-if="customers"
                        :disabled="!form.branch_id ||isTechnician"
                        :model.sync="form.customer_id"
                        :multiple="false"
                        :values="customers"
                        label="full_name"
                        track-by="id"
                    ></multiple-select-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('customer_id') && !$v.form.customer_id.required"
                        :state="validateState('customer_id') && $v.form.customer_id.required">
                      {{ $t('services.validations.customer.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6">
                  <b-form-group :label="$t('services.open_date')">
                    <b-form-input
                        v-model="form.open_date"
                        :state="validateState('open_date')"
                        class="form-control form-control-solid"
                        name="open_date"
                        type="date"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('open_date') && !$v.form.open_date.required"
                        :state="validateState('open_date') && $v.form.open_date.required">
                      {{ $t('services.validations.open_date.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="12" md="12" sm="12" xl="12">
                  <b-form-group :label="$t('services.service_files')">
                    <b-form-file
                        v-model="form.service_files"
                        :drop-placeholder="$t('services.file_placeholder')"
                        :placeholder="$t('services.file_placeholder')"
                        :disabled="isTechnician"
                        multiple
                        @input="uploadFile($event, 1)"
                    ></b-form-file>
                  </b-form-group>
                </b-col>

                <b-col lg="12" md="12" sm="12" xl="12">
                  <b-form-group :label="$t('services.description')">
                    <b-form-textarea
                        v-model="form.description"
                        :placeholder="$t('services.description')"
                        :state="validateState('description')"
                        class="form-control form-control-solid"
                        :disabled="isTechnician"
                        name="description"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                        v-if="!validateState('description') && !$v.form.description.required"
                        :state="!(validateState('description') && !$v.form.description.required)">
                      {{ $t('services.validations.description.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6" v-if="!isFirstViewForCustomer">
                  <b-form-group :label="$t('services.start_date')">
                    <b-form-input
                        v-model="form.start_date"
                        class="form-control form-control-solid"
                        name="start_date"
                        :disabled="isCustomer"
                        type="date"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('start_date') && !$v.form.start_date.required"
                        :state="validateState('start_date') && $v.form.start_date.required">
                      {{ $t('services.validations.start_date.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6" v-if="!isFirstViewForCustomer">
                  <b-form-group :label="$t('services.end_date')">
                    <b-form-input
                        v-model="form.end_date"
                        class="form-control form-control-solid"
                        name="end_date"
                        :disabled="isCustomer"
                        type="date"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('end_date') && !$v.form.end_date.required"
                        :state="validateState('end_date') && $v.form.end_date.required">
                      {{ $t('services.validations.end_date.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6" v-if="!isFirstViewForCustomer">
                  <b-form-group :label="$t('services.team_type')">
                    <multiple-select-input
                        v-if="teamTypes"
                        :model.sync="form.team_type_id"
                        :multiple="false"
                        :values="teamTypes"
                        :disabled="isCustomer || isTechnician"
                        label="name"
                        track-by="id"
                    ></multiple-select-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('team_type_id') && !$v.form.team_type_id.required"
                        :state="true">
                      {{ $t('services.validations.team_type.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6" v-if="!isFirstViewForCustomer">
                  <b-form-group :label="$t('services.technician')">
                    <multiple-select-input
                        v-if="technicians"
                        :disabled="!form.branch_id && !form.team_type_id || isCustomer || isTechnician"
                        :model.sync="form.technician_id"
                        :multiple="false"
                        :values="technicians"
                        label="name"
                        track-by="id"
                    ></multiple-select-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('technician_id') && !$v.form.technician_id.required"
                        :state="true">
                      {{ $t('services.validations.technician.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="12" md="12" sm="12" xl="12" v-if="!isFirstViewForCustomer">
                  <b-form-group :label="$t('services.action_taken')">
                    <b-form-textarea
                        v-model="form.action_taken"
                        :placeholder="$t('services.action_taken')"
                        :state="validateState('action_taken')"
                        class="form-control form-control-solid"
                        name="description"
                        :disabled="isCustomer"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                        v-if="!validateState('action_taken') && !$v.form.action_taken.required"
                        :state="true">
                      {{ $t('services.validations.action_taken.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="12" md="12" sm="12" xl="12" v-if="!isFirstViewForCustomer">
                  <div class="d-flex justify-content-between mb-3">
                 <span class="h4">
                   {{ $t('services.materials') }}
                 </span>
                    <b-button variant="warning" class="text-white btn-icon" @click="addMaterial" :disabled="isCustomer">
                      <i class='bx bx-plus' ></i>
                    </b-button>
                  </div>
                </b-col>

                <template v-for="(material, index) in form.materials" v-if="!isFirstViewForCustomer">
                  <b-col lg="4" md="4" sm="12" xl="4">
                    <b-form-group :label="$t('services.materials')">
                      <multiple-select-input
                          v-if="materials"
                          :model.sync="material.material_id"
                          :multiple="false"
                          :disabled="isCustomer"
                          :values="materials"
                          label="name"
                          track-by="id"
                          @onSelect="onMaterialSelect($event, index)"
                      ></multiple-select-input>
                      <b-form-invalid-feedback
                          v-if="!validateState('material_id', index) && !$v.form.materials.$each[index].material_id.required"
                          :state="validateState('material_id', index) && $v.form.materials.$each[index].material_id.required">
                        {{ $t('services.validations.material.required') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>

                  <b-col lg="4" md="4" sm="12" xl="4">
                    <b-form-group :label="$t('materials.amount')">
                      <b-form-input
                          v-model="material.net_amount"
                          :max="material.max_amount || 0"
                          :placeholder="$t('materials.amount')"
                          :state="validateState('net_amount', index)"
                          class="form-control form-control-solid"
                          name="amount"
                          :disabled="isCustomer"
                          type="number"
                      ></b-form-input>
                      <b-form-invalid-feedback
                          v-if="!validateState('net_amount', index) && !$v.form.materials.$each[index].net_amount.required"
                          :state="true">
                        {{ $t('materials.validations.amount.required') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>

                  <b-col lg="4" md="4" sm="12" xl="4">
                    <b-form-group :label="$t('services.unit')">
                      <multiple-select-input
                          v-if="units"
                          :model.sync="material.unit_id"
                          :multiple="false"
                          :values="units"
                          :disabled="isCustomer"
                          label="code"
                          track-by="id"
                      ></multiple-select-input>
                      <b-form-invalid-feedback
                          v-if="!validateState('unit_id', index) && !$v.form.materials.$each[index].unit_id.required"
                          :state="validateState('unit_id', index) && $v.form.materials.$each[index].unit_id.required">
                        {{ $t('services.validations.unit.required') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>

                </template>

                <b-col lg="12" md="12" sm="12" xl="12" v-if="!isFirstViewForCustomer">
                  <b-form-group :label="$t('services.files')">
                    <b-form-file
                        v-model="form.files"
                        :drop-placeholder="$t('services.file_placeholder')"
                        :placeholder="$t('services.file_placeholder')"
                        multiple
                        @input="uploadFile($event, 2)"
                    ></b-form-file>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6" v-if="!isFirstViewForCustomer">
                  <b-form-group :label="$t('services.authorized_person')">
                    <b-form-input
                        v-model="form.authorized_person"
                        :placeholder="$t('services.authorized_person')"
                        :state="validateState('authorized_person')"
                        class="form-control form-control-solid"
                        name="amount"
                        :disabled="isCustomer"
                        type="text"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        v-if="!validateState('authorized_person') && !$v.form.authorized_person.required"
                        :state="true">
                      {{ $t('services.validations.authorized_person.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="12" xl="6" v-if="!isFirstViewForCustomer">
                  <b-form-group :label="$t('services.authorized_person_sign')">
                    <b-form-file
                        :disabled="isCustomer"
                        v-model="form.authorized_person_sign"
                        :drop-placeholder="$t('services.file_placeholder')"
                        :placeholder="$t('services.file_placeholder')"
                    ></b-form-file>
                    <b-form-invalid-feedback
                        v-if="!validateState('authorized_person_sign') && !$v.form.authorized_person_sign.required"
                        :state="validateState('authorized_person_sign') && $v.form.authorized_person_sign.required">
                      {{ $t('services.validations.authorized_person_sign.required') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col lg="12" md="12" sm="12" xl="12" v-if="!isFirstViewForCustomer">
                  <div class="d-flex justify-content-between mb-3">
                    <span class="h4">
                      {{ $t('services.customer_files') }}
                    </span>
                  </div>
                </b-col>

                <template v-for="(file, index) in customerFiles" v-if="form.id">
                  <b-col lg="3" md="3" sm="12" xl="3" class="text-center">

                    <template v-if="isImage(file.mime_type)">
                      <img :id="`img-` + file.id"
                           :src="file.file_link"
                           class="img-fluid img-thumbnail img-service-file"
                           v-if="isImage(file.mime_type)">
                    </template>

                    <template v-else-if="isVideo(file.mime_type)">
                      <video controls :src="file.file_link" class="img-service-file"></video>
                    </template>

                    <template v-else-if="isPdf(file.mime_type)">
                      <img :id="`img-` + file.id"
                           :src="pdfImageIconUrl"
                           class="img-fluid img-thumbnail img-service-file">
                    </template>

                    <template v-else>
                      <img :id="`img-` + file.id"
                           :src="fileImageIconUrl"
                           class="img-fluid img-thumbnail img-service-file"
                      >
                    </template>
                    <div class="text-center">
                      <b-btn
                          v-if="isOperator || isSuperAdmin || ((isCustomer || isTechnician) && authUser.id === file.user_id)"
                          class="btn-icon mt-2 ml-2 text-white"
                          variant="danger"
                          @click="deleteFile(file)">
                          <i class="bx bx-trash-alt"></i>
                      </b-btn>

                      <b-link
                          target="_blank"
                          :href="file.file_link"
                          role="button"
                          class="btn btn-icon btn-success mt-2 ml-2 text-white">
                        <i class='bx bxs-download'></i>
                      </b-link>
                    </div>
                  </b-col>
                </template>

                <b-col lg="12" md="12" sm="12" xl="12" class="mt-3" v-if="!isFirstViewForCustomer">
                  <div class="d-flex justify-content-between mb-3 mt-3">
                    <span class="h4">
                      {{ $t('services.technician_files') }}
                    </span>
                  </div>
                </b-col>

                <template v-for="(file, index) in technicianFiles" v-if="form.id">
                  <b-col lg="3" md="3" sm="12" xl="3" class="text-center">
                    <template v-if="isImage(file.mime_type)">
                      <img :id="`img-` + file.id"
                           :src="file.file_link"
                           class="img-fluid img-thumbnail img-service-file"
                           v-if="isImage(file.mime_type)">
                    </template>

                    <template v-else-if="isVideo(file.mime_type)">
                      <video controls :src="file.file_link" class="img-service-file"></video>
                    </template>

                    <template v-else-if="isPdf(file.mime_type)">
                      <img :id="`img-` + file.id"
                           :src="pdfImageIconUrl"
                           class="img-fluid img-thumbnail img-service-file">
                    </template>

                    <template v-else>
                      <img :id="`img-` + file.id"
                           :src="fileImageIconUrl"
                           class="img-fluid img-thumbnail img-service-file"
                      >
                    </template>

                    <div class="text-center">

                      <b-btn
                          v-if="isOperator || isSuperAdmin || ((isCustomer || isTechnician) && authUser.id === file.user_id)"
                          class="btn-icon mt-2 ml-2 text-white"
                          variant="danger"
                          @click="deleteFile(file)">
                        <i class="bx bx-trash-alt"></i>
                      </b-btn>

                      <b-link
                          target="_blank"
                          :href="file.file_link"
                          role="button"
                          class="btn btn-icon btn-success mt-2 ml-2 text-white">
                        <i class='bx bxs-download'></i>
                      </b-link>
                    </div>
                  </b-col>
                </template>

                <b-col
                    class="float-right text-right"
                    lg="12"
                    md="12"
                    sm="12"
                    xl="12"
                >
                  <b-button
                      class="mr-1"
                      variant="secondary"
                      @click="goBack"
                  >
                    <i class="fas fa-arrow-left"></i>
                    {{ $t("general.cancel") }}
                  </b-button>
                  <b-button variant="primary" @click="createOrUpdate()">
                    <i class="far fa-save"></i>
                    {{ $t(id != null ? "general.save" : "general.create") }}
                  </b-button>
                </b-col>
              </b-row>
              </p>
            </b-tab>
            <b-tab :title="$t('services.service_history')" :disabled="!id"><p>
              <service-history-table v-if="id" :service_id="id" />
            </p></b-tab>
            <b-tab :title="$t('services.service_report')" :disabled="!id">
              <p>
                <b-col lg="12" md="12" sm="12" xl="12">
                  <div class="py-1"> <span class="font-weight-bold"> {{ $t('services.start_date')}} : </span> <span class="pull-right">{{ form.start_date}}</span>  </div>
                  <div class="py-1"> <span class="font-weight-bold"> {{ $t('services.end_date')}} : </span> <span class="pull-right">{{ form.end_date}}</span>  </div>
                  <div class="py-1"> <span class="font-weight-bold"> {{ $t('services.customer')}} : </span> <span class="pull-right">{{ form.customer ? form.customer.full_name : '-'}}</span>  </div>
                  <div class="py-1"> <span class="font-weight-bold"> {{ $t('services.technician')}} : </span> <span class="pull-right">{{ form.technician ? form.technician.full_name : '-'}}</span>  </div>
                  <div class="py-1"> <span class="font-weight-bold"> {{ $t('services.total_time')}} : </span> <span class="pull-right">{{ form.total_time ? form.total_time : 0 }} </span>  </div>
                </b-col>

                <b-col lg="12" md="12" sm="12" xl="12" v-if="form.service_status_id && +form.service_status_id === 9">
                  <div class="py-1">
                    <span class="font-weight-bold"> {{ $t('services.download_pdf')}}</span>
                    <br>
                    <a :href="form.pdf_link" target="_blank"><img :src="pdfImageIconUrl" class="img-fluid service-pdf-download-img" /> </a>
                  </div>
                </b-col>
              </p>
            </b-tab>
          </b-tabs>
        </template>
      </dashboard-box>
    </div>

    <b-modal
        id="modal-service-description"
        ref="modal-service-description"
        :title="$t('services.description_title')"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
            :label="$t('services.description')"
            label-for="description-input"
            :invalid-feedback="$t('services.validations.description.required')"
            :state="descriptionState"
        >
          <b-form-textarea
              id="name-input"
              v-model="description"
              :state="descriptionState"
              required
          ></b-form-textarea>
        </b-form-group>
      </form>

      <template #modal-footer="{ ok, cancel }">
        <button  @click="cancel()" type="button" class="btn btn btn-primary text-white btn-secondary btn-sm">
          {{ $t('general.cancel') }}
        </button>
        <button type="button" class="btn text-white btn-primary btn-sm" @click="ok()">
          {{ $t('general.ok') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import DataTable from "@/assets/components/dataTable/DataTable";
import ServiceHistoryTable from "@/view/pages/management/services/ServiceHistoryTable";
import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  DELETE_FILE,
  ERROR,
  FILES,
  GET_FILES,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  TIME_STATUS,
  TIME_SUCCESS,
  TIMES_SERVICE,
  UPDATE_ITEM,
  UPLOAD_FILE,
  HISTORIES,
  GET_HISTORIES
} from "@/core/services/store/service.module";

import institutionModule, {
  GET_ALL_ITEMS as GET_INSTITUTION_ITEMS,
  ITEMS_ALL as INSTITUTION_ITEMS,
  MODULE_NAME as INSTITUTION_MODULE_NAME
} from "@/core/services/store/institution.module";

import branchModule, {
  GET_ALL_ITEMS as GET_BRANCH_ITEMS,
  ITEMS_ALL as BRANCH_ITEMS,
  MODULE_NAME as BRANCH_MODULE
} from "@/core/services/store/branch.module";

import userModule, {
  CUSTOMERS,
  GET_CUSTOMERS,
  GET_TECHNICIANS,
  MODULE_NAME as USER_MODULE,
  TECHNICIANS,
} from "@/core/services/store/user.module";

import serviceTypeModule, {
  GET_ALL_ITEMS as GET_SERVICE_TYPE_ITEMS,
  ITEMS_ALL as SERVICE_TYPE_ITEMS,
  MODULE_NAME as SERVICE_TYPE_MODULE
} from "@/core/services/store/serviceType.module";

import serviceStatusModule, {
  GET_ALL_ITEMS as GET_SERVICE_STATUS_ITEMS,
  ITEMS_ALL as SERVICE_STATUS_ITEMS,
  MODULE_NAME as SERVICE_STATUS_MODULE
} from "@/core/services/store/serviceStatus.module";

import regionModule, {
  GET_ALL_ITEMS as GET_REGION_ITEMS,
  ITEMS_ALL as REGION_ITEMS,
  MODULE_NAME as REGION_MODULE
} from "@/core/services/store/region.module";

import teamType, {
  GET_ALL_ITEMS as GET_TEAM_TYPE_ITEMS,
  ITEMS_ALL as TEAM_TYPE_ITEMS,
  MODULE_NAME as TEAM_TYPE_MODULE
} from "@/core/services/store/teamType.module";

import materialModule, {
  GET_USER_ITEMS as GET_MATERIAL_ITEMS,
  USER_ITEMS as MATERIAL_ITEMS,
  MODULE_NAME as MATERIAL_MODULE,
  BASE_URL as MATERIAL_BASE_URL
} from "@/core/services/store/material.module";

import unitModule, {
  GET_ALL_ITEMS as GET_UNIT_ITEMS,
  ITEMS_ALL as UNIT_ITEMS,
  MODULE_NAME as UNIT_MODULE
} from "@/core/services/store/unit.module";

import store from "@/core/services/store";
import {validationMixin} from "vuelidate";
import {required, requiredIf} from "vuelidate/lib/validators";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import _ from "lodash";
import moment from "moment";
import {LARAVEL_DATE_FORMAT, LARAVEL_DATE_TIME_FORMAT} from "@/core/config/constant";

const _MODULE_NAME = MODULE_NAME;
const _INSTITUTION_MODULE_NAME = INSTITUTION_MODULE_NAME;
const _BRANCH_MODULE = BRANCH_MODULE;
const _USER_MODULE = USER_MODULE;
const _SERVICE_STATUS_MODULE = SERVICE_STATUS_MODULE;
const _SERVICE_TYPE_MODULE = SERVICE_TYPE_MODULE;
const _REGION_MODULE = REGION_MODULE;
const _TEAM_TYPE_MODULE = TEAM_TYPE_MODULE;
const _MATERIAL_MODULE = MATERIAL_MODULE;
const _UNIT_MODULE = UNIT_MODULE;

export default {
  name: "ServicesCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
    registerStoreModule(_INSTITUTION_MODULE_NAME, institutionModule);
    registerStoreModule(_BRANCH_MODULE, branchModule);
    registerStoreModule(_USER_MODULE, userModule);
    registerStoreModule(_SERVICE_STATUS_MODULE, serviceStatusModule);
    registerStoreModule(_SERVICE_TYPE_MODULE, serviceTypeModule);
    registerStoreModule(_REGION_MODULE, regionModule);
    registerStoreModule(_TEAM_TYPE_MODULE, teamType);
    registerStoreModule(_MATERIAL_MODULE, materialModule);
    registerStoreModule(_UNIT_MODULE, unitModule);

  },
  components: {
    DashboardBox,
    DataTable,
    MultipleSelectInput,
    ServiceHistoryTable
  },
  validations() {
    if (this.isCustomer) {
      return {
        form: {
          institution_id: {
            required
          },
          branch_id: {
            required
          },
          customer_id: {
            required
          },
          open_date: {
            required
          },
          description: {
            required
          },
          service_status_id: {
          },
          service_type_id: {
            required
          },
          technician_id: {
          },
          team_type_id: {
          },
          action_taken: {
          },
          authorized_person: {
          },
          authorized_person_sign: {
          },
          start_date: {
          },
          end_date: {
          },
          materials: {
            $each: {
              material_id: {
              },
              net_amount: {
              },
              unit_id: {
              }
            }
          },
        }
      }
    }

    if (this.isTechnician) {
      return {
        form: {
          institution_id: {
          },
          branch_id: {
          },
          customer_id: {
          },
          open_date: {
          },
          description: {
          },
          service_type_id: {
          },
          technician_id: {
          },
          team_type_id: {
          },
          service_status_id: {
            required
          },
          action_taken: {
            required: requiredIf(function() {
              return this.form.service_status_id && this.form.service_status_id === 8
            }),
          },
          authorized_person: {
            required: requiredIf(function() {
              return this.form.service_status_id && this.form.service_status_id === 8
            }),
          },
          authorized_person_sign: {
            required: requiredIf(function() {
              return this.form.service_status_id && this.form.service_status_id === 8
            }),
          },
          start_date: {
            required
          },
          end_date: {
            required: requiredIf(function() {
              return this.form.service_status_id && this.form.service_status_id === 8
            }),
          },
          materials: {
            $each: {
              material_id: {
                required: requiredIf(function() {
                  return this.form.service_status_id && this.form.service_status_id === 8
                }),
              },
              net_amount: {
                required: requiredIf(function() {
                  return this.form.service_status_id && this.form.service_status_id === 8
                }),
              },
              unit_id: {
                required: requiredIf(function() {
                  return this.form.service_status_id && this.form.service_status_id === 8
                }),
              }
            }
          },
        }
      }
    }
    if (this.isOperator) {
      return {
        form: {
          institution_id: {
            required
          },
          branch_id: {
            required
          },
          customer_id: {
            required
          },
          open_date: {
            required
          },
          description: {
            required
          },
          service_status_id: {
            required
          },
          service_type_id: {
            required
          },
          technician_id: {
            required
          },
          team_type_id: {
            required
          },
          action_taken: {
          },
          authorized_person: {
          },
          authorized_person_sign: {
          },
          start_date: {
          },
          end_date: {
          },
          materials: {
            $each: {
              material_id: {
              },
              net_amount: {
              },
              unit_id: {
              }
            }
          },
        }
      }
    }

    return {
      form: {
        institution_id: {
          required
        },
        branch_id: {
          required
        },
        customer_id: {
          required
        },
        open_date: {
          required
        },
        description: {
          required
        },
        service_status_id: {
          required
        },
        service_type_id: {
          required
        },
        technician_id: {
          required
        },
        team_type_id: {
          required
        },
        action_taken: {
          required
        },
        authorized_person: {
          required: requiredIf(function() {
            return this.form.team_type_id && this.form.team_type_id !== 4
          }),
        },
        authorized_person_sign: {
          required: requiredIf(function() {
            return this.form.team_type_id && this.form.team_type_id !== 4
          }),
        },
        start_date: {
        },
        end_date: {
        },
        materials: {
          $each: {
            material_id: {
              required
            },
            net_amount: {
              required
            },
            unit_id: {
              required
            }
          }
        },
      }
    }

  },
  computed: {
    isFirstViewForCustomer() {
      return this.isCustomer && !this.id
    },
    isAuthorizedToEdit() {
      return (this.isSuperAdmin || this.isOperator)
    },
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
      return store.getters[_MODULE_NAME + "/" + ITEM];
    },
    timeStatus() {
      return store.getters[_MODULE_NAME + "/" + TIME_STATUS];
    },
    histories() {
      return store.getters[_MODULE_NAME + "/" + HISTORIES];
    },
    timeSuccess() {
      return store.getters[_MODULE_NAME + "/" + TIME_SUCCESS];
    },
    institutions() {
      return store.getters[_INSTITUTION_MODULE_NAME + "/" + INSTITUTION_ITEMS] || [];
    },
    branches() {
      return store.getters[_BRANCH_MODULE + "/" + BRANCH_ITEMS] || [];
    },
    technicians() {
      return store.getters[_USER_MODULE + "/" + TECHNICIANS] || [];
    },
    customers() {
      return store.getters[_USER_MODULE + "/" + CUSTOMERS] || [];
    },
    serviceTypes() {
      return store.getters[_SERVICE_TYPE_MODULE + "/" + SERVICE_TYPE_ITEMS] || [];
    },
    serviceStatuses() {
      let items =  store.getters[_SERVICE_STATUS_MODULE + "/" + SERVICE_STATUS_ITEMS] || [];
      if (items.length && !this.id && !this.form.service_status_id) {
        this.form.service_status_id = items.find(item => item.id ===  1);
      }
      return items;
    },
    teamTypes() {
      return store.getters[_TEAM_TYPE_MODULE + "/" + TEAM_TYPE_ITEMS] || [];
    },
    regions() {
      return store.getters[_REGION_MODULE + "/" + REGION_ITEMS] || [];
    },
    materials() {
      let items = store.getters[_MATERIAL_MODULE + "/" + MATERIAL_ITEMS];

      if (items) {
        items.forEach(item => {
          item.name = item.material.name
        })

        return items;
      }
      return [];
    },
    units() {
      return store.getters[_UNIT_MODULE + "/" + UNIT_ITEMS] || [];
    },
    files() {
      return store.getters[_MODULE_NAME + "/" + FILES];
    },
    customerFiles() {
      let files = [];

      if (this.form && this.form.existing_files) {
        files = this.form.existing_files.filter(item => +item.type === 1)
      }

      return files;
    },
    technicianFiles() {
      let files = [];

      if (this.form && this.form.existing_files) {
        files = this.form.existing_files.filter(item => +item.type === 2)
      }

      return files;
    },
  },
  data() {
    return {
      currentTypeId: 1,
      description: "",
      descriptionState: null,
      id: this.$route.params.id,
      defaultMaterial: {
        material_id: null,
        net_amount: null,
        unit_id: null,
      },
      form: {
        customer_id: null,
        technician_id: null,
        open_date: moment().format(LARAVEL_DATE_FORMAT),
        start_date: null,
        files: [],
        service_files: [],
        end_date: null,
        service_type_id: null,
        service_status_id: null,
        description: "",
        action_taken: "",
        institution_id: null,
        branch_id: null,
        team_type_id: null,
        authorized_person: null,
        authorized_person_sign: null,
        materials: []
      }
    };
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.descriptionState = valid
      return valid
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-service-description')
      })

      this.actionService(this.currentTypeId);
    },
    resetModal() {
      this.description = ''
      this.descriptionState = null
    },
    onMaterialSelect(data, index) {
      this.form.materials[index].net_amount = this.form.materials[index].net_amount || Number(data.amount);
      this.form.materials[index].max_amount = Number(data.amount);
      this.form.materials[index].unit_id = data.unit;
      this.form.materials[index].material_id = data.material_id;
    },
    addMaterial() {
      if (this.form.materials) {
        this.form.materials.push(this.defaultMaterial);
      } else {
        this.$set(this.form, 'materials', []);
        this.form.materials.push(this.defaultMaterial);
      }
    },
    showServiceDescriptionModal(type) {
      this.currentTypeId = type;
      this.$refs['modal-service-description'].show();
    },
    actionService(type = 1) {
      let url = BASE_URL + '/' + this.id + '/times';
      let formData = {
        type_id: type,
        description: this.description
      }

      this.$store
          .dispatch(_MODULE_NAME + "/" + TIMES_SERVICE, {
            url: url,
            contents: formData,
          });
    },
    uploadFile(files, type = 1) {
      if (this.id && files && files.length) {
        let self = this;
        let form = new FormData();
        files.forEach(file => {
          form.append('files[]', file);
        })

        form.append('type', type)
        let url = BASE_URL + '/' + this.id + '/file';
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPLOAD_FILE, {
              url: url,
              contents: form,
            }).then((response) => {
          if (response.status) {
            setTimeout(() => {
              self.sweetAlertSuccess(response.data.message).then(() => {
                self.$store.dispatch(_MODULE_NAME + "/" + GET_FILES, {
                  url: url
                })
              });
            }, 200);
          }
        });
      }
    },
    deleteFile(item) {
      let self = this;
      this.sweetAlertConfirm(
          this.$t("general.are_you_sure"),
          function (self) {
            let url = BASE_URL + "/" + self.id + '/file/' + item.id;
            self.$store
                .dispatch(_MODULE_NAME + "/" + DELETE_FILE, {
                  url: url
                }).then(response => {
              if (response.status) {
                setTimeout(() => {
                  self.sweetAlertSuccess(response.data.message).then(() => {
                    url = BASE_URL + "/" + self.id + '/file';
                    self.$store.dispatch(_MODULE_NAME + "/" + GET_FILES, {
                      url: url
                    })
                  });
                }, 100);
              }
            })
          });
    },
    goBack() {
      this.$router.push({name: "management.services"})
    },
    validateState(name, index) {
      if (!(_.isNull(index) || _.isUndefined(index))) {
        const {$dirty, $error} = this.$v.form.materials.$each[index][name]
        return $dirty ? !$error : null;
      } else {
        const {$dirty, $error} = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    getItem() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    getHistories() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_HISTORIES, {
            url: BASE_URL + "/" + this.id + '/history',
          })
    },
    getInstitutions() {
      this.$store
          .dispatch(_INSTITUTION_MODULE_NAME + "/" + GET_INSTITUTION_ITEMS, {})
    },
    getBranches() {
      let filter = {
        institution_id: this.form.institution_id || null
      }
      this.$store
          .dispatch(_BRANCH_MODULE + "/" + GET_BRANCH_ITEMS, {
            filters: filter
          })
    },
    getServiceTypes() {
      this.$store
            .dispatch(_SERVICE_TYPE_MODULE + "/" + GET_SERVICE_TYPE_ITEMS, {})
    },
    getMaterials() {
      if (this.form.technician_id) {
        let url = MATERIAL_BASE_URL + '/user/' + this.form.technician_id

        this.$store
            .dispatch(_MATERIAL_MODULE + "/" + GET_MATERIAL_ITEMS, {
              url: url
            })
      }
    },
    getServiceStatuses() {
      this.$store
          .dispatch(_SERVICE_STATUS_MODULE + "/" + GET_SERVICE_STATUS_ITEMS, {})
    },
    getRegions() {
      this.$store
            .dispatch(_REGION_MODULE + "/" + GET_REGION_ITEMS, {})
    },
    getTeamTypes() {
      this.$store
          .dispatch(_TEAM_TYPE_MODULE + "/" + GET_TEAM_TYPE_ITEMS, {})

    },
    getUnits() {
      this.$store
            .dispatch(_UNIT_MODULE + "/" + GET_UNIT_ITEMS, {})
    },
    getCustomers() {
      let filter = {
        branch_id: this.form.branch_id || null,
        team_type_id: this.form.team_type_id || null,
      }

      this.$store
          .dispatch(_USER_MODULE + "/" + GET_CUSTOMERS, {
            filters: filter,
          })
    },
    getTechnicians() {
      if (!this.form.branch_id || !this.form.team_type_id) {
        return false;
      }

      let filter = {
        branch_id: this.form.branch_id,
        team_type_id: this.form.team_type_id
      }

      this.$store
          .dispatch(_USER_MODULE + "/" + GET_TECHNICIANS, {
            filters: filter,
          })
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let formData = _.clone(this.form);

      if (this.id) {
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.id,
              contents: formData
            });
      } else {
        let form = new FormData();

        if (this.form.institution_id) {
          form.append('institution_id', this.form.institution_id);
        }

        if (this.form.branch_id) {
          form.append('branch_id', this.form.branch_id);
        }

        if (this.form.technician_id) {
          form.append('technician_id', this.form.technician_id);
        }

        if (this.form.service_type_id) {
          form.append('service_type_id', this.form.service_type_id);
        }

        if (this.form.service_status_id) {
          form.append('service_status_id', this.form.service_status_id);
        }

        if (this.form.team_type_id) {
          form.append('team_type_id', this.form.team_type_id);
        }

        if (this.form.customer_id) {
          form.append('customer_id', this.form.customer_id);
        }

        form.append('open_date', this.form.open_date);

        if (this.form.authorized_person) {
          form.append('authorized_person', this.form.authorized_person);
        }

        if (this.form.authorized_person_sign) {
          form.append('authorized_person_sign', this.form.authorized_person_sign);
        }

        if (formData.materials && formData.materials.length) {
          formData.materials.forEach((item, index) => {
            form.append('materials[' + index + '][material_id]', item.material_id);
            form.append('materials[' + index + '][unit_id]', item.unit_id);
            form.append('materials[' + index + '][net_amount]', item.net_amount);
          })
        }

        if (this.form.start_date) {
          form.append('start_date', this.form.start_date);
        }

        if (this.form.end_date) {
          form.append('end_date', this.form.end_date);
        }

        form.append('description', this.form.description);
        form.append('action_taken', this.form.action_taken);

        if (this.form.files && this.form.files.length) {
          this.form.files.forEach(file => {
            form.append('files[]', file);
          })
        }

        if (this.form.service_files && this.form.service_files.length) {
          this.form.service_files.forEach(file => {
            form.append('service_files[]', file);
          })
        }

        this.$store
            .dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: form,
            });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "services.edit_item" : "services.create_item")}
    ]);

    if (this.institutions && !this.institutions.length) {
      this.getInstitutions();

    }
    if (this.serviceTypes && !this.serviceTypes.length) {
      this.getServiceTypes();
    }

    if (this.serviceStatuses && !this.serviceStatuses.length) {
      this.getServiceStatuses();
    }

    if (this.technicians && !this.technicians.length && this.form.branch_id) {
      this.getTechnicians();
    }

    if (this.customers && !this.customers.length && this.form.branch_id) {
      this.getCustomers();
    }

    if (this.regions && !this.regions.length) {
      this.getRegions();
    }

    if (this.teamTypes && !this.teamTypes.length) {
      this.getTeamTypes();
    }

    if (!this.institutions && this.form.institution_id) {
      this.getBranches();
    }

    if (this.units && !this.units.length) {
      this.getUnits();
    }

    if (this.id) {
      this.getItem();
    } else {
      if (this.isCustomer) {
        this.form.authorized_person = this.authUser.full_name;
      }
    }
  },
  watch: {
    'form.technician_id': {
      handler: function (newValue, oldValue) {
        if (newValue)
          this.getMaterials();
      }
    },
    'form.institution_id': {
      handler: function (newValue, oldValue) {
        if (newValue)
          this.getBranches();
      }
    },
    'form.branch_id': {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.getCustomers();
          this.getTechnicians();
        }
      },
    },
    'form.team_type_id': {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.getTechnicians();
        }
      }
    },
    files(item) {
      if (item && item.length) {
        this.form.existing_files = [];
        this.form.existing_files = _.clone(item)
        this.form.files = null;
        this.form.service_files = null;
        this.form.authorized_person_sign = null;
      }
    },
    item(value) {
      if (value) {
        let item = value.hasOwnProperty('item') ? value.item : value;

        if (item.institution_id && typeof item.institution_id !== 'object') {
          item.institution_id = item.institution.id;
        }

        if (item.branch_id && typeof item.branch_id !== 'object') {
          item.branch_id = item.branch.id;
        }

        if (item.customer_id && typeof item.customer_id !== 'object') {
          item.customer_id = item.customer.id;
        }

        if (item.technician_id && typeof item.technician_id !== 'object') {
          item.technician_id = item.technician.id;
        }

        if (item.team_type_id && typeof item.team_type_id !== 'object') {
          item.team_type_id = item.team_type.id;
        }

        if (item.service_type_id && typeof item.service_type_id !== 'object') {
          item.service_type_id = item.service_type.id;
        }

        if (item.service_status_id && typeof item.service_status_id !== 'object') {
          item.service_status_id = item.service_status.id;
        }

        if (item.open_date) {
          item.open_date = moment(item.open_date, LARAVEL_DATE_TIME_FORMAT).format(LARAVEL_DATE_FORMAT)
        }

        if (item.start_date) {
          item.start_date = moment(item.start_date, LARAVEL_DATE_TIME_FORMAT).format(LARAVEL_DATE_FORMAT)
        }

        if (item.end_date) {
          item.end_date = moment(item.end_date, LARAVEL_DATE_TIME_FORMAT).format(LARAVEL_DATE_FORMAT)
        }

        if (item.materials) {

          let materials = [];

          item.materials.forEach( item => {
            materials.push({
              material_id: item.material,
              net_amount: item.amount,
              unit_id: item.unit,
            })
          })

          item.materials = materials;
         }

        if (item.files) {
          item.existing_files = _.clone(item.files)
          item.files = null;
          item.files = [];
          item.service_files = [];
          item.authorized_person_sign = null;
        }

        this.form = item;
      }
    },
    timeSuccess(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(self.$t("general.successfully_saved"),
              (response) => {
                self.getItem()
              });
        }, 100)
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(self.$t("general.successfully_saved"),
              (response) => {
                if (response) {
                  self.$router.push({name: "management.services"});
                }
              });
        }, 100)
      }
    }
  }
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}

.img-service-file {
  height: 16vh !important;
  width: 10vw !important;
  object-fit: contain;
}

.service-pdf-download-img {
  height: 8vh !important;
  width: 3vw !important;
}

.border-box {
  border: 1px solid #ccc;
  padding: 10px 20px;
  border-radius: 10px;
}
</style>
